const PRODUCTION_HOSTS = new Set(['edubridgeinsight.com', 'www.edubridgeinsight.com'])
export const PRODUCTION_API_BASE_URL = 'https://api.edubridgeinsight.com/api'
const DEV_API_HOST = 'expert-bridge-api.apps.openxcell.dev'

function isProductionHost(hostname: string): boolean {
  const host = hostname.split(':')[0].toLowerCase()
  return PRODUCTION_HOSTS.has(host) || host.endsWith('.edubridgeinsight.com')
}

/**
 * The production site must never call the OpenXcell dev API, even if
 * next dev loaded .env.development or an old container env.
 */
export function resolveApiBaseUrl(hostname?: string): string {
  const fromEnv = process.env.NEXT_PUBLIC_API_BASE_URL || ''

  if (hostname && isProductionHost(hostname)) {
    return PRODUCTION_API_BASE_URL
  }

  if (typeof window !== 'undefined' && isProductionHost(window.location.hostname)) {
    return PRODUCTION_API_BASE_URL
  }

  if (fromEnv.includes(DEV_API_HOST) && hostname && isProductionHost(hostname)) {
    return PRODUCTION_API_BASE_URL
  }

  return fromEnv
}
